import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "utilityVanMedium"
const UtilityVanMediumIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M16.919 6.188C17.807 6.188 18.594 6.756 18.875 7.598L19.96 10.851 21.587 11.665C22.03 11.887 22.313 12.342 22.313 12.839V16.125C22.313 16.85 21.725 17.438 21 17.438H19.523C19.069 18.222 18.22 18.75 17.25 18.75S15.431 18.222 14.977 17.438H9.023C8.569 18.222 7.72 18.75 6.75 18.75S4.931 18.222 4.477 17.438H3C2.275 17.438 1.688 16.85 1.688 16.125V7.5C1.688 6.775 2.274 6.188 3 6.188zM6.75 15C6.129 15 5.625 15.504 5.625 16.125S6.129 17.25 6.75 17.25 7.875 16.746 7.875 16.125 7.371 15 6.75 15M17.25 15C16.629 15 16.125 15.504 16.125 16.125S16.629 17.25 17.25 17.25 18.375 16.746 18.375 16.125 17.871 15 17.25 15M3 7.313C2.896 7.313 2.813 7.396 2.813 7.5V11.438H3C3.31 11.438 3.563 11.689 3.563 12 3.563 12.31 3.31 12.563 3 12.563H2.813V13.313H3C3.31 13.313 3.563 13.564 3.563 13.875 3.563 14.185 3.31 14.438 3 14.438H2.813V16.125C2.813 16.229 2.896 16.313 3 16.313H4.133Q4.126 16.22 4.125 16.125C4.125 14.675 5.3 13.5 6.75 13.5S9.375 14.675 9.375 16.125Q9.374 16.219 9.367 16.313H14.633Q14.626 16.22 14.625 16.125C14.625 14.675 15.8 13.5 17.25 13.5S19.875 14.675 19.875 16.125Q19.874 16.219 19.867 16.313H21C21.104 16.313 21.188 16.229 21.188 16.125V14.438H21C20.69 14.438 20.438 14.186 20.438 13.875S20.689 13.313 21 13.313H21.188V12.839C21.188 12.768 21.147 12.703 21.084 12.67L19.367 11.813H15.375C14.65 11.813 14.063 11.225 14.063 10.5V7.313zM15.188 10.5C15.188 10.604 15.27 10.688 15.375 10.688H18.719L17.81 7.953C17.68 7.571 17.321 7.313 16.918 7.313H15.187z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UtilityVanMediumIcon
